export class LogCategoryFilter {
    constructor(transport, options) {
        this.transport = transport;
        this.options = options;
    }
    write(log) {
        var _a, _b;
        const { category } = log;
        // check includes
        if (((_a = this.options.includes) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            !this.options.includes.some((test) => category.match(test))) {
            return;
        }
        // check excludes
        if (((_b = this.options.excludes) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
            this.options.excludes.some((test) => category.match(test))) {
            return;
        }
        this.transport.write(log);
    }
}
